<div class="page-content-wrapper">
  <div class="col-sm-12">
    <div class="row g-4">
      <div class="col-md-4 mb-2 mt-4">
         <icon-card
           title="Available Services"
           :count="null"
           :show_button="true"
           :icon_class="'fa fa-cogs'"
           @click="view_client_services"
         />
       </div>
    </div>

    <div class="card rounded-3 mt-3 border-1 shadow">
      <div class="card-header bg-white border-0">
        <p class="text-s fw-bold">Project Services</p>
      </div>
      <div class="card-body">
        <CustomTable
          :columns="columns"
          :fetchData="get_services"
          :key="get_services"
          :hasActions="true"
          tableKey="project_services"
        >
          <template v-slot:actions="{ row }">
            <button
              class="btn bg-green secondary-text-dark rounded-3 fw-bold btn-sm me-2 text-xs text-white"
              @click="view_service(row.service_id)"
            >
              View
            </button>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</div>